function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0C5.37 0 0 5.373 0 12s5.37 12 11.995 12z",
  fill: "#13426B"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0C5.37 0 0 5.373 0 12s5.37 12 11.995 12z",
  fill: "#13426B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0C5.37 0 0 5.373 0 12s5.37 12 11.995 12z",
  fill: "url(#basic-background-check_svg__paint0_linear)",
  fillOpacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "basic-background-check_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0C5.37 0 0 5.373 0 12s5.37 12 11.995 12z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.995 24c6.624 0 11.995-5.373 11.995-12S18.62 0 11.995 0C5.37 0 0 5.373 0 12s5.37 12 11.995 12z",
  stroke: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#basic-background-check_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.394
}, /*#__PURE__*/React.createElement("mask", {
  id: "basic-background-check_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 5,
  width: 25,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.82 5.33l11.22 11.302-12.206 12.294L6.822 17.66c.257-6.158 11.997-12.33 11.997-12.33z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#basic-background-check_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.07 19.21c5.062 0 9.165-4.134 9.165-9.232 0-5.1-4.103-9.232-9.165-9.232-5.061 0-9.165 4.133-9.165 9.232 0 5.098 4.104 9.232 9.165 9.232z",
  fill: "#000"
}))), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.37 5.117L12.145 4.07a1.022 1.022 0 0 0-.341 0L5.579 5.117c-.5.084-.867.52-.867 1.031v7.322c0 4.881 6.651 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.284-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("mask", {
  id: "basic-background-check_svg__c",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 4,
  width: 16,
  height: 17
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.37 5.117L12.145 4.07a1.022 1.022 0 0 0-.341 0L5.579 5.117c-.5.084-.867.52-.867 1.031v7.322c0 4.881 6.651 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.284-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.185 10.064a.573.573 0 0 0-.164-.4l-.797-.802a.567.567 0 0 0-.797 0l-3.844 3.87-1.723-1.737a.567.567 0 0 0-.797 0l-.797.8a.573.573 0 0 0 0 .802l2.121 2.132.797.802a.567.567 0 0 0 .797 0l.797-.802 4.243-4.265a.573.573 0 0 0 .164-.4z",
  fill: "#E25829"
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "basic-background-check_svg__paint0_linear",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.5
})));

var SvgBasicBackgroundCheck = function SvgBasicBackgroundCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "0bd0d046b35a2946bebab3f25c2c69dd.svg";
export { SvgBasicBackgroundCheck as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/basic-background-check.svg
// module id = null
// module chunks = 